import styled from "styled-components";
import Tab from "components/Tab";
import { MainBlockContainer } from "components/Common/components";

type TabProps = "deviceManagement" | "userManagement";

interface settingTypeProps {
  selectedType: string;
  handleSelectType: (type: TabProps) => void;
}

const Container = styled(MainBlockContainer)`
  background: transparent;
  margin-bottom: 0px;
  padding-top: 0px;
  padding-left: 0px;
  padding-bottom: 0px;
  margin-left: 0px;
  color: #586b7c;
`;

const SettingTypeList = [
  { value: "power_temp", title: "Power And Outdoor temp" },
  // { value: "iso_50006", title: "ISO50006" },
  { value: "ac_env_zone", title: "Temperature each zone" },
  { value: "temp_rh_zone", title: "Temp vs RH each zone" },
  { value: "aqi", title: "AQI" },
  { value: "people_in_out", title: "People IN/OUT" },
  { value: "people_in_out_x_power", title: "People IN/OUT x Power" },
];

const DaikinSettingTypeSection = ({ selectedType, handleSelectType }: settingTypeProps) => {
  return (
    <>
      <Container>
        <Tab dataList={SettingTypeList} selectedValue={selectedType} handleSelect={handleSelectType} />
      </Container>
    </>
  );
};

export default DaikinSettingTypeSection;
